import Icon from "../../../../../assets/spaceicons/detail.svg";
import {
  SpaceComponentPackage,
  SpaceComponentHostType,
  SpaceComponentTags
} from "../../../../../types";
import { DEFAULT_SIZES } from "../../../layout/constants";
import {
  DEFAULT_ELEMENT_LAYOUT_OPTIONS,
  ElementLayout,
  OverflowOption
} from "../../../layout/util";

import Config from "./Config";
import errorSelector from "./Config/errorSelector";
import componentConfigReducer, {
  makeInitialState,
  ensureSpaceDetailComponent,
  DetailConfigState
} from "./Config/reducer";
import { getSchema } from "./getSchema";
import SpaceDetail from "./SpaceDetail";
import { SpaceDetailComponent, SpaceDetailProperties } from "./types";

const pkg: SpaceComponentPackage<
  SpaceDetailProperties,
  SpaceDetailComponent,
  DetailConfigState
> = {
  type: "DETAIL",
  displayName: "Detail",
  Icon,
  allowedHosts: new Set<SpaceComponentHostType>(["SPACE", "FLEX_BOX"]),
  isRepeatable: false,
  Component: SpaceDetail,
  ConfigurationComponent: Config,
  componentConfigReducer,
  getInitialDraftState: makeInitialState,
  ensureComponent: ensureSpaceDetailComponent,
  getSchema,
  defaultElementLayout: new ElementLayout({
    width: DEFAULT_SIZES.TALL.width,
    height: DEFAULT_SIZES.TALL.height,
    snapToGrid: true
  }),
  elementLayoutOptions: {
    ...DEFAULT_ELEMENT_LAYOUT_OPTIONS,
    overflow: [OverflowOption.HIDDEN]
  },
  allowSelfBinding: false,
  allowAncestorBinding: true,
  tags: [SpaceComponentTags.Base],
  isHeadless: false,
  errorSelector,
  isContainer: false
};

export default pkg;
